import { render, staticRenderFns } from "./CalcView.vue?vue&type=template&id=34a22c30&scoped=true"
import script from "./CalcView.vue?vue&type=script&lang=ts"
export * from "./CalcView.vue?vue&type=script&lang=ts"
import style0 from "./CalcView.vue?vue&type=style&index=0&id=34a22c30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a22c30",
  null
  
)

export default component.exports